import React from 'react';
import axios from "axios";
import { useState, useEffect, useMemo } from 'react';
import MaterialReactTable from 'material-react-table';
import { useNavigate, useLocation } from "react-router-dom";
const Forms = () => {
    const navigate = useNavigate();
    const [value, setvalue] = useState("");
    const [formsData, setFormsData] = useState([]);
    const { state } = useLocation();
    const [flag, setFlag] = useState(false);

    const [formNameValue, setFormNameValue] = useState("");
    const [formAreaValue, setFormAreaValue] = useState("");
    const [formControllerValue, setFormControllerValue] = useState("");
    const [formActionValue, setFormActionValue] = useState("");
    const [sortingOrderValue, setSortingOrderValue] = useState("");
    const [schemeValue, setSchemeValue] = useState("");
    const [schemeData, setSchemeData] = useState([]);
    const [formCodeValue, setFormCodeValue] = useState("");

    useEffect(() => {
        const fetchData = async () => {
            const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/forms`);
            setFormsData(result.data.dataContent);
          
        };
        fetchData();
    }, []);

   

    useEffect(() => {
        if (state) {
           
            setFormCodeValue(state.cropSurveyCode.rO_FormCode)
            setFormNameValue(state.cropSurveyCode.formName)
            setFormAreaValue(state.cropSurveyCode.formArea)
            setFormControllerValue(state.cropSurveyCode.formController)
            setFormActionValue(state.cropSurveyCode.formAction)
            setSortingOrderValue(state.cropSurveyCode.sortingOrder)
            getScheme()
            setSchemeValue(state.cropSurveyCode.schemeCode)
        }
    }, [])


    function ValidateForms() {
        let valid = false;
         if(formNameValue === "") {
             valid = false;
            alert("Enter Correct Form Name")
            return;
         }else {
             valid = true
         }
         if(formActionValue === "") {
             valid = false;
            alert("Enter Correct Form Action")
            return;
         }else {
             valid = true
         }
         if(schemeValue === "") {
             valid = false;
            alert("Select Any Scheme")
            return;
         }else {
             valid = true
         }
         if(formControllerValue === "") {
            valid = false;
            alert("Enter Correct Form Controller Value")
            return;
         }else {
             valid = true;           
         }
         if(sortingOrderValue === "") {
            valid = false;
           alert("Enter Correct Sorting Order")
           return;
        }else {
            valid = true
        }
     
        
     
         if(valid === true) {
            state ? UpdateForm() : AddNewForms()
         }
     
       }

    function AddNewForms() {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "SchemeCode": schemeValue,
            "FormName": formNameValue,
            "FormAction": formActionValue,
            "FormController": formControllerValue,
            "FormArea": formAreaValue,
            "SortingOrder": sortingOrderValue,
            "CreatedByUC": localStorage.getItem("userCodeGlobal")
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/forms`, requestOptions)
            .then(response => response.text())
            .then((result) => {
                alert(JSON.parse(result).message);
                if (JSON.parse(result).success == true) {
                    setFlag(true);
                    navigate("/usermanagement/forms")
                }

            })
            .catch(error => console.log('error', error));
    }

    function getScheme() {
        const fetchScheme = async () => {
            let result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/scheme`);
            let filterResult = result.data.dataContent.filter(function (el) { return String(el.schemeCode) === localStorage.getItem("schemeCodeSingle")})
            setSchemeData(filterResult);
        };
        fetchScheme();
    }

    function UpdateForm() {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "RO_FormCode": formCodeValue,
            "SchemeCode": schemeValue,
            "FormName": formNameValue,
            "FormAction": formActionValue,
            "FormController": formControllerValue,
            "FormArea": formAreaValue,
            "SortingOrder": sortingOrderValue,
            "IsActive": "Y",
            "CreatedByUC": localStorage.getItem("userCodeGlobal")
        });

        var requestOptions = {
            method: 'PUT',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/forms`, requestOptions)
            .then(response => response.text())
            .then((result) => {
                alert(JSON.parse(result).message);
                if (JSON.parse(result).success == true) {
                    setFlag(true);
                    navigate("/usermanagement/forms")
                }

            })
            .catch(error => console.log('error', error));
    }

    function handleResetForm(){
        setFormNameValue("")
        setFormAreaValue("")
        setFormControllerValue("")
        setFormActionValue("")
        setSchemeValue("")
        setSortingOrderValue("")
    }

    return (
        <>
           
            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>Add New Form</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">User Management</li>
                            <li className="breadcrumb-item active">Add New Form</li>
                        </ol>
                    </nav>
                </div>
                <section className="section">
                    <div className="card dashboard">
                        <div className="card-body">
                         
                            <form className="g-3 addNewUser">
                                <div className="row">


                                    <div className="col-md-3">
                                        <label for="State" className="form-label">Form Name</label>
                                        <input className="form-control" type="text" placeholder="Form Name" onChange={e => setFormNameValue(e.target.value)} value={formNameValue} />
                                    </div>
                                    <div className="col-md-3">
                                        <label for="State" className="form-label">Form Area</label>
                                        <input className="form-control" type="text" placeholder="Form Area" onChange={e => setFormAreaValue(e.target.value)} value={formAreaValue} />
                                    </div>
                                    <div className="col-md-3">
                                        <label for="State" className="form-label">Form Controller</label>
                                        <input className="form-control" type="text" placeholder="Form Controller" onChange={e => setFormControllerValue(e.target.value)} value={formControllerValue} />
                                    </div>
                                    <div className="col-md-3">
                                        <label for="State" className="form-label">Form Action</label>
                                        <input className="form-control" type="text" placeholder="Form Action" onChange={e => setFormActionValue(e.target.value)} value={formActionValue} />
                                    </div>
                                    <div className="col-md-4">
                                        <label for="scheme" className="form-label">Scheme Name</label>
                                        <select id="scheme" required className="form-select" onClick={getScheme} onChange={e => setSchemeValue(e.target.value)} value={schemeValue}>
                                            <option selected>Choose...</option>
                                            {schemeData.map((item, id) => {
                                                return <option key={id} value={item.schemeCode}> {item.schemeName}</option>
                                            })}
                                        </select>
                                    </div>
                                    <div className="col-md-3">
                                        <label for="District" className="form-label">Sorting Order</label>
                                        <input className="form-control" type="number" placeholder="Sorting Order" onChange={e => setSortingOrderValue(e.target.value)} value={sortingOrderValue} />
                                    </div>
                                    {/*<div className="col-md-3">*/}
                                    {/*    <label for="Block" className="form-label">Is Active?</label>*/}
                                    {/*    <select id="Block" className="form-select">*/}
                                    {/*        <option selected>Choose...</option>*/}
                                    {/*        <option>Yes</option>*/}
                                    {/*        <option>No</option>*/}

                                    {/*    </select>*/}
                                    {/*</div>*/}



                                    <div className="col-md-3 justify-content-md-center">
                                    <br/>
                                  
                                        {state ? <button className="btn btn-success me-md-2" type="button" onClick={ValidateForms}>Update</button> : <button className="btn btn-success me-md-2" type="button" onClick={ValidateForms}>Save</button>}
                                        <button className="btn btn-outline-primary me-md-2" type="button" onClick={handleResetForm}>Reset</button>
                                        <button className="btn btn-outline-danger me-md-2" type="button" onClick={() => navigate("/usermanagement/forms")}>Cancel</button>
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </section>
          

            </main>
           
        </>
    )
}

export default Forms;

